import { emitSustainabilityLabelClickEvent } from "./eventEmitter";

/**
 *
 *
 *
 *
 */

/**
 *
 */
export default ({ variationId, cinemaType, sustainabilityTag }) => {
    emitSustainabilityLabelClickEvent({
        product_VariationId: variationId,
        product_SustainabilityFeature: cinemaType,
        product_SustainabilityTags: sustainabilityTag.toLowerCase(),
        product_SustainabilityActivity: "click",
    });
};
